<template>
  <div>
    <div class="row b-form__container_type_flex b-form__row_type_flex-end">
      <div class="col-4">
        <label>{{$t('CONTENT.discountRates.rate')}}:<span class="b-form__required"> *</span></label>
        <numeric class="b-numeric" controls :max="100" :disabled="isDisabledSetDiscountRate" v-model="discountRate"></numeric>
      </div>
      <div class="col-4 b-form__container_type_flex">
        <checkbox class="b-checkbox mb-2" id="isAuto" v-model="discountIsAuto">{{$t('CONTENT.discountRates.isAutoDiscount')}}</checkbox>
        <dynamic-icon class="ml-1 mb-2" v-tooltip="$t('CONTENT.hints.isAutoDiscountHint')" icon="question"></dynamic-icon>
      </div>
    </div>
    <div class="row mt-5 b-form__container_type_flex b-form__row_type_flex-end">
      <div class="col-8">
        <div>
          <label>{{$t('CONTENT.comment')}}:</label>
          <textarea class="b-textarea" v-model.lazy="newDiscount.commentary"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetDiscount from "../../models/commands/SetDiscount";

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newDiscount: {
        id: null,
        discountRate: null,
        isAuto: true,
        commentary: null
      },
    };
  },
  created() {
    this.init();
  },
  watch: {
    discountIsAuto(newVal, oldVal) {
      if(oldVal === false && newVal) {
        this.newDiscount.discountRate = null;
      }
    }
  },
  computed: {
    isDisabledSetDiscountRate() {
      return !!this.newDiscount.isAuto;
    },
    discountRate: {
      get() {
        if (this.newDiscount.discountRate !== null) {
          return this.newDiscount.discountRate;
        }
      },
      set(newVal) {
        if(isNaN(newVal)) {
          this.newDiscount.discountRate = null;
        } else {
          this.newDiscount.discountRate = newVal;
        }
      }
    },
    discountIsAuto: {
      get() {
        return this.newDiscount.isAuto;
      },
      set(newVal) {
        this.newDiscount.isAuto = newVal;
      }
    }
  },
  methods: {
    init() {
      if (this.paymentParams.discount.id !== null) {
        this.newDiscount = {
          id: this.paymentParams.discount.id,
          isAuto: this.paymentParams.discount.isAuto,
          discountRate: this.paymentParams.discount.discountRate,
          commentary: this.paymentParams.discount.commentary
        };
      } else {
        this.newDiscount = {};
      }
    },

    cancel() {
      this.init();
    },

    save() {
      const command = new SetDiscount(
        this.paymentParams.idInDB,
        this.newDiscount
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
